export default __webpack_public_path__ + "static/media/Privacy-Policy.63366bc2.jpg";